module.exports = __webpack_public_path__ + "img/cigarette.ddfc87bb.svg";